// Borrar un trabajador con registros firmados (M45): la app lo impide ANTES de intentar el borrado, con un mensaje
// claro. Sin esto, el primer paso del borrado (los exámenes del trabajador) choca con el bloqueo de M45
// (firmas_bloqueo_origen) y el usuario ve un error genérico. La base no cambia.
//  - Cuenta: registros del trabajador en firma o firmados (EPP y aptitud médica) y sus firmas (también las de
//    asistencia, que guardan el worker_id del firmante).
//  - Si la base todavía no tiene M45 (error al leer), no bloquea: la base sigue protegiendo igual.

import { supabase } from '../../supabaseClient';

export const MENSAJE_TRABAJADOR_CON_FIRMAS =
  'Este trabajador tiene registros firmados (asistencia, EPP o aptitud médica) que se conservan como evidencia; no puede borrarse.';

interface Conteo { count: number | null; error: unknown }
export interface ConsultaFirmasTrabajador {
  registros(workerId: string): PromiseLike<Conteo>;
  firmas(workerId: string): PromiseLike<Conteo>;
}

const consultaSupabase: ConsultaFirmasTrabajador = {
  registros: id => supabase.from('signed_records').select('id', { head: true, count: 'exact' })
    .eq('worker_id', id).neq('status', 'abierto'),
  firmas: id => supabase.from('signed_record_signatures').select('id', { head: true, count: 'exact' })
    .eq('worker_id', id),
};

const hay = (c: Conteo) => !c.error && (c.count ?? 0) > 0;

export async function trabajadorTieneRegistrosFirmados(
  workerId: string,
  consulta: ConsultaFirmasTrabajador = consultaSupabase,
): Promise<boolean> {
  if (!workerId) return false;
  const [r, f] = await Promise.all([consulta.registros(workerId), consulta.firmas(workerId)]);
  return hay(r) || hay(f);
}
